import React, { Component } from "react";
import { FormGroup, FormControl, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./style.scss";
import Authentication from "../api/Authentication/AuthenticationService";
import { Input, Row, Col, Button } from "antd";
import loginBackground from "../images/custom_bg.png";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../redux/reducers/Users/actions";

class login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      Username: null,
      password: null,
    };
  }

  usernameOnChange = (e) => {
    this.setState({ Username: e.target.value });
    localStorage.setItem("user", e.target.value);
  };
  passwordOnChange = (e) => {
    this.setState({ password: e.target.value });
  };

  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.handleLogin();
    }
  };

  authenticate = (username, password) => {
    Authentication.authenticate({ id_no: username, password: password })
      .then((response) => {
        if (
          response.data.role === "admin" ||
          response.data.role === "moderator"
        ) {
          localStorage.setItem("user-auth", response.data.token);
          localStorage.setItem("role", response.data.role);
          toast.success(`Welcome ${this.state.username}`, {
            position: toast.POSITION.TOP_CENTER,
          });
          this.props.history.push("/settings");
        } else {
          toast.warning(`Please Check your benefits through mobile App`, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch((err) => {
        toast.error("Username or password incorrect", {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  handleLogin = () => {
    this.authenticate(this.state.Username, this.state.password);
  };

  enterPressed = (event) => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      //13 is the enter keycode
      this.authenticate(this.state.username, this.state.password);
    }
  };

  render() {
    return (
      <div className="Login" align="center">
        <Card className="w-50 rounded-0">
          <Row gutter={24}>
            <Col span={16}>
              <img
                src={loginBackground}
                width="100%"
                height="100%"
                alt="background"
              />
            </Col>
            <Col span={8}>
              <form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this._handleKeyDown(e);
                  }
                }}
                onSubmit={this.handleSubmit}
              >
                <Row gutter={24} className="w-100 mb-5" align="center">
                  <Col span={24} className=" mt-5">
                    <FormGroup controlId="logo" align="center">
                      <img
                        id="main-logo"
                        className="logo-login"
                        src={require("../images/logo.png")}
                        alt="Shards Dashboard"
                      />
                    </FormGroup>
                  </Col>
                  <Col span={24} className="w-100">
                    <FormGroup controlId="email" align="center"></FormGroup>
                  </Col>
                  <Col span={24} className="w-100">
                    <FormGroup controlId="email">
                      <FormControl
                        autoFocus
                        type="text"
                        placeholder="USER ID"
                        className="large-rounded-input mr-3"
                        style={{ width: "170px" }}
                        onChange={this.usernameOnChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col span={24} className="w-100">
                    <FormGroup controlId="password">
                      <FormControl
                        className="large-rounded-input mr-3"
                        placeholder="PASSWORD"
                        onChange={this.passwordOnChange}
                        type="password"
                      />
                    </FormGroup>
                  </Col>
                  <Col span={24} className="w-100">
                    <Input
                      type="button"
                      className="red-rounded-button mr-3"
                      onClick={this.handleLogin}
                      value="LOGIN"
                    ></Input>
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>
        </Card>
        <Button
          shape="circle"
          className="circle-floating-button"
          onClick={() => this.props.history.push("/main")}
        ></Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { user: state.userData.user };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(login);
